export const telephoneData = {
  talk1: {
    type: "telephone",
    title: "Restaurant Reservation Confirmation & Change Request",
    titleKr: "레스토랑 예약 확인 및 변경 요청",
    versions: {
      basic: {
        script: `Hello, Mr. Carter. This is Olivia from Riverside Steakhouse calling regarding your dinner reservation. I received your message <mark>requesting to change the time</mark>.
Your original reservation was for Saturday, March 9, at 7:30 p.m. We have moved it to 8:00 p.m. as requested. However, please note that we can only hold your table for 15 minutes after the scheduled time.
Also, I wanted to confirm your request for <mark>a window seat</mark>. We have made a note of it, but window seating is subject to availability.
If you have any other requests or need to modify your reservation again, <mark>please call us back</mark> at (555) 892-4456. We look forward to seeing you this weekend!`,
        translation: `안녕하세요, 카터 님. 리버사이드 스테이크하우스의 올리비아입니다. 저녁 예약과 관련하여 연락드립니다. 시간 변경 요청하신 메시지를 받았습니다.
원래 예약하신 시간은 3월 9일 토요일 오후 7시 30분이었는데, 요청하신 대로 오후 8시로 변경해 드렸습니다. 다만, 예약 시간 이후 15분까지만 테이블을 유지할 수 있다는 점 참고해 주세요.
또한, 창가 자리 요청을 확인하고 싶었습니다. 요청사항을 기록해 두었지만, 창가 좌석은 이용 가능 여부에 따라 달라질 수 있습니다.
다른 요청사항이 있으시거나 예약을 다시 변경하셔야 할 경우, (555) 892-4456으로 다시 연락 주시기 바랍니다. 이번 주말에 뵙기를 기대하겠습니다!`,
        audioUrl: {
          us: "audios/part4/telephone/us/us1.mp3",
          uk: "audios/part4/telephone/uk/uk1.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What does the speaker say about the reservation?",
        questionKr: "화자는 예약에 대해 무엇이라고 말합니까?",
        options: {
          A: "The restaurant <mark>cannot accept changes</mark>",
          B: "<mark>The time</mark> has been adjusted as requested",
          C: "The reservation has been <mark>canceled</mark>",
          D: "The table will be ready <mark>early</mark>",
        },
        optionsKr: {
          A: "레스토랑이 변경을 수락할 수 없다",
          B: "요청한 대로 시간이 조정되었다",
          C: "예약이 취소되었다",
          D: "테이블이 일찍 준비될 것이다",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 레스토랑이 변경을 수락할 수 없다
B: 요청한 대로 시간이 조정되었다
C: 예약이 취소되었다
D: 테이블이 일찍 준비될 것이다

정답 B: 스크립트의 "We have moved it to 8:00 p.m. as requested"에서 요청한 대로 예약 시간이 조정되었음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker mention about <mark>seating</mark>?",
        questionKr: "화자는 좌석에 대해 무엇이라고 언급합니까?",
        options: {
          A: "A <mark>larger table</mark> has been prepared",
          B: "A <mark>window seat</mark> request has been noted",
          C: "The customer must choose a <mark>different table</mark>",
          D: "<mark>Outdoor seating</mark> is available",
        },
        optionsKr: {
          A: "더 큰 테이블이 준비되었다",
          B: "창가 자리 요청이 기록되었다",
          C: "고객이 다른 테이블을 선택해야 한다",
          D: "야외 좌석이 이용 가능하다",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 더 큰 테이블이 준비되었다
B: 창가 자리 요청이 기록되었다
C: 고객이 다른 테이블을 선택해야 한다
D: 야외 좌석이 이용 가능하다

정답 B: 스크립트의 "We have made a note of it, but window seating is subject to availability"에서 창가 자리 요청이 기록되었음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker suggest the <mark>listener</mark> do?",
        questionKr: "화자는 청취자에게 무엇을 제안합니까?",
        options: {
          A: "<mark>Arrive on time</mark>",
          B: "<mark>Call again</mark> if changes are needed",
          C: "Confirm the reservation by <mark>email</mark>",
          D: "Ask for a <mark>discount</mark>",
        },
        optionsKr: {
          A: "정시에 도착하기",
          B: "변경이 필요하면 다시 전화하기",
          C: "이메일로 예약 확인하기",
          D: "할인 요청하기",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 정시에 도착하기
B: 변경이 필요하면 다시 전화하기
C: 이메일로 예약 확인하기
D: 할인 요청하기

정답 B: 스크립트의 "If you have any other requests or need to modify your reservation again, please call us back"에서 변경이 필요하면 다시 전화하라고 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },
  talk2: {
    type: "telephone",
    title: "Doctor's Appointment Rescheduling",
    versions: {
      basic: {
        script: `Hello, Mr. Johnson. This is Sarah from Oakwood Medical Center. I'm calling to confirm your appointment with Dr. Stevens scheduled for Monday, March 12 at 10:00 a.m.
I understand that you'd like to reschedule. <mark>We can move your appointment to Wednesday, March 14 at 2:00 p.m.</mark> Unfortunately, we don't have any availability earlier that day.
Also, <mark>please remember to bring any medical documents</mark> that might be necessary for the consultation. <mark>If you need to make any further changes, feel free to call</mark> us at (555) 789-1234.
Thank you for your understanding, and we look forward to seeing you on March 14.`,
        translation: `안녕하세요, 존슨 님. 오크우드 메디컬 센터의 사라입니다. 3월 12일 월요일 오전 10시로 예약된 스티븐스 박사와의 진료 예약을 확인하고자 연락드렸습니다.
일정 변경을 원하신다고 알고 있습니다. 3월 14일 수요일 오후 2시로 예약을 변경해 드릴 수 있습니다. 죄송하지만, 그날은 더 이른 시간대의 예약이 불가능합니다.
또한, 진료에 필요할 수 있는 의료 서류를 반드시 가져오시기 바랍니다. 추가 변경이 필요하시다면 (555) 789-1234로 연락 주시기 바랍니다.
이해해 주셔서 감사드리며, 3월 14일에 뵙기를 기대하겠습니다.`,
        audioUrl: {
          us: "audios/part4/telephone/us/us2.mp3",
          uk: "audios/part4/telephone/uk/uk2.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question:
          "What does the speaker say about the <mark>rescheduled appointment</mark>?",
        options: {
          A: "The appointment was <mark>canceled</mark>",
          B: "The new appointment time is on <mark>March 16 at 2:00 p.m.</mark>",
          C: "The original appointment will <mark>remain unchanged</mark>",
          D: "The appointment can be moved to an <mark>earlier time</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 예약이 취소되었다
B: 새 예약 시간은 3월 16일 오후 2시이다
C: 원래 예약이 그대로 유지될 것이다
D: 예약을 더 이른 시간으로 옮길 수 있다

정답 B: 스크립트의 "We can move your appointment to Wednesday, March 14 at 2:00 p.m."에서 새 예약 시간이 3월 14일 오후 2시임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What should the <mark>listener bring</mark> to the appointment?",
        options: {
          A: "A <mark>payment</mark> for the consultation",
          B: "Any <mark>medical documents</mark>",
          C: "A list of <mark>previous treatments</mark>",
          D: "A <mark>health insurance</mark> card",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 진료비 지불금
B: 의료 서류
C: 이전 치료 목록
D: 건강보험 카드

정답 B: 스크립트의 "please remember to bring any medical documents that might be necessary for the consultation"에서 의료 서류를 가져와야 한다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What should the listener do if they need to make further changes?",
        options: {
          A: "<mark>Visit the hospital</mark> in person",
          B: "<mark>Send an email</mark> to confirm",
          C: "<mark>Call the hospital</mark> at the provided number",
          D: "Make an appointment <mark>online</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 병원에 직접 방문하기
B: 이메일로 확인하기
C: 제공된 번호로 병원에 전화하기
D: 온라인으로 예약하기

정답 C: 스크립트의 "If you need to make any further changes, feel free to call us at (555) 789-1234"에서 추가 변경이 필요할 경우 제공된 번호로 전화하라는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk3: {
    type: "telephone",
    title: "Meeting Rescheduling",
    versions: {
      basic: {
        script: `Hello, this is John Parker from Innovate Solutions. I'm calling to inform you that we need to reschedule the meeting originally planned for Thursday, March 5th. Due to unforeseen circumstances, our key team members will be unavailable on that day.
I'd like to suggest <mark>moving the meeting to Monday, March 9th at 10:00 a.m.</mark> However, <mark>if this time is inconvenient for you, we are open to other suggestions.</mark> Please confirm your availability as soon as possible so we can finalize the schedule.`,
        translation: `안녕하세요, 이노베이트 솔루션스의 존 파커입니다. 3월 5일 목요일로 예정되어 있던 회의 일정을 변경해야 해서 연락드립니다. 예상치 못한 상황으로 인해 주요 팀원들이 그날 참석할 수 없게 되었습니다.
3월 9일 월요일 오전 10시로 회의를 옮기는 것을 제안드리고 싶습니다. 하지만, 이 시간이 불편하시다면 다른 제안도 받아들일 수 있습니다. 일정을 확정할 수 있도록 가능한 한 빨리 참석 가능 여부를 알려주시기 바랍니다.`,
        audioUrl: {
          us: "audios/part4/telephone/us/us3.mp3",
          uk: "audios/part4/telephone/uk/uk3.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "Why is the speaker calling?",
        options: {
          A: "To <mark>confirm</mark> a meeting schedule",
          B: "To <mark>cancel</mark> a meeting",
          C: "To suggest a <mark>new meeting</mark> <mark>time</mark>",
          D: "To discuss the <mark>meeting agenda</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 회의 일정을 확인하기 위해
  B: 회의를 취소하기 위해
  C: 새로운 회의 시간을 제안하기 위해
  D: 회의 안건을 논의하기 위해
  
  정답 C: 스크립트의 "I'd like to suggest moving the meeting to Monday, March 9th"에서 새로운 회의 시간을 제안하기 위해 전화했음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is the new proposed time for the meeting?",
        options: {
          A: "<mark>Monday</mark> at <mark>9:00</mark> a.m.",
          B: "<mark>Thursday</mark> at <mark>10:00</mark> a.m.",
          C: "<mark>Monday</mark> at <mark>10:00</mark> a.m.",
          D: "<mark>Thursday</mark> at <mark>9:00</mark> a.m.",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 월요일 오전 9시
  B: 목요일 오전 10시
  C: 월요일 오전 10시
  D: 목요일 오전 9시
  
  정답 C: 스크립트의 "Monday, March 9th at 10:00 a.m."에서 새로 제안된 회의 시간이 월요일 오전 10시임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          'What does the speaker mean by saying "we are <mark>open to other suggestions</mark>"?',
        options: {
          A: "They are willing to change the meeting <mark>location</mark>",
          B: "They are open to discussing other <mark>topics</mark>",
          C: "They are willing to change the meeting <mark>time</mark>",
          D: "They are asking for additional <mark>team members</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 회의 장소를 변경할 의향이 있다
  B: 다른 주제를 논의할 의향이 있다
  C: 회의 시간을 변경할 의향이 있다
  D: 추가 팀원을 요청하고 있다
  
  정답 C: 스크립트의 "if this time is inconvenient for you, we are open to other suggestions"에서 제안된 시간이 불편할 경우 다른 시간으로 변경할 수 있다는 의미임을 알 수 있습니다.`,
      },
    ],
  },
  talk4: {
    type: "telephone",
    title: "Document Submission Request",
    versions: {
      basic: {
        script: `Hello, this is Sarah Collins from the marketing department at Creative Solutions. I'm <mark>reaching out regarding the quarterly sales report that was due last week</mark>. Unfortunately, we have not yet received your submission.
<mark>Please send the completed report by Wednesday, March 4th</mark>, as we need to review it before the management meeting scheduled for next week. <mark>If you have any questions or if there are any issues with the report, please let me know as soon as possible</mark>.
I appreciate your attention to this matter and look forward to receiving the report.`,
        translation: `안녕하세요, 크리에이티브 솔루션스 마케팅 부서의 사라 콜린스입니다. 지난주까지 제출하기로 했던 분기별 매출 보고서와 관련하여 연락드립니다. 아직 보고서를 받지 못했습니다.
다음 주로 예정된 경영진 회의 전에 검토해야 하므로, 3월 4일 수요일까지 완성된 보고서를 보내주시기 바랍니다. 질문이 있으시거나 보고서와 관련된 문제가 있으시다면 최대한 빨리 알려주시기 바랍니다.
이 건에 대해 관심 가져주셔서 감사드리며, 보고서를 받아볼 수 있기를 기대하겠습니다.`,
        audioUrl: {
          us: "audios/part4/telephone/us/us4.mp3",
          uk: "audios/part4/telephone/uk/uk4.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "Why is the speaker calling?",
        options: {
          A: "To <mark>remind</mark> the listener about a <mark>meeting</mark>",
          B: "To <mark>confirm the submission</mark> of a report",
          C: "To <mark>request</mark> a report <mark>submission</mark>",
          D: "To <mark>explain</mark> the report's <mark>importance</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 회의를 상기시키기 위해
  B: 보고서 제출을 확인하기 위해
  C: 보고서 제출을 요청하기 위해
  D: 보고서의 중요성을 설명하기 위해
  
  정답 C: 스크립트의 "Please send the completed report by Wednesday, March 4th"에서 보고서 제출을 요청하기 위해 전화했음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is the <mark>new deadline</mark> for the report?",
        options: {
          A: "<mark>Monday</mark>, March 2nd",
          B: "<mark>Wednesday</mark>, March 4th",
          C: "<mark>Friday</mark>, March 6th",
          D: "<mark>Thursday</mark>, March 5th",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 3월 2일 월요일
  B: 3월 4일 수요일
  C: 3월 6일 금요일
  D: 3월 5일 목요일
  
  정답 B: 스크립트의 "Please send the completed report by Wednesday, March 4th"에서 새로운 제출 기한이 3월 4일 수요일임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker suggest the listener do if there are issues with the report?",
        options: {
          A: "Call the <mark>manager</mark>",
          B: "<mark>Submit the report</mark> immediately",
          C: "<mark>Let the speaker know</mark> as soon as possible",
          D: "<mark>Wait</mark> until the <mark>next</mark> <mark>meeting</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 매니저에게 전화하기
  B: 즉시 보고서 제출하기
  C: 가능한 한 빨리 화자에게 알리기
  D: 다음 회의까지 기다리기
  
  정답 C: 스크립트의 "If you have any questions or if there are any issues with the report, please let me know as soon as possible"에서 문제가 있을 경우 즉시 알려달라고 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk6: {
    type: "telephone",
    title: "Publishing House Manuscript Review",
    versions: {
      basic: {
        script: `Hello, this is Anna Parker from <mark>Greenfield Publishing</mark>. I'm calling to follow up on your recent submission of your manuscript titled The Secret Garden. I've reviewed your work with the editorial team, and we think it has great potential. However, we would like to make a few adjustments to the storyline and some character developments.
<mark>We'd like you to visit our office next week</mark> to discuss these changes in more detail with the editor. Would Monday at 10 AM work for you? If not, we are happy to schedule another time that suits you.
Let us know how you'd like to proceed. <mark>We're excited about working with you on this project!</mark>`,
        translation: `안녕하세요, 그린필드 출판사의 애나 파커입니다. 최근 제출하신 '비밀 정원'이라는 제목의 원고에 대해 후속 연락을 드립니다. 편집팀과 함께 작품을 검토했는데, 큰 잠재력이 있다고 생각합니다. 다만, 스토리라인과 일부 캐릭터 발전 부분에 약간의 조정이 필요할 것 같습니다.
다음 주에 사무실로 방문해 주셔서 편집자와 함께 이러한 변경 사항에 대해 더 자세히 논의하고 싶습니다. 월요일 오전 10시는 어떠신가요? 만약 안되신다면, 귀하께 맞는 다른 시간으로 일정을 잡을 수 있습니다.
어떻게 진행하고 싶으신지 알려주세요. 이 프로젝트에서 귀하와 함께 일하게 되어 매우 기대됩니다!`,
        audioUrl: {
          us: "audios/part4/telephone/us/us6.mp3",
          uk: "audios/part4/telephone/uk/uk6.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "Where does the speaker most likely work?",
        options: {
          A: "At a <mark>library</mark>",
          B: "At an <mark>education center</mark>",
          C: "At a <mark>bookstore</mark>",
          D: "At a <mark>publishing company</mark>",
        },
        correctAnswer: "D",
        explanation: `[선택지 해석]
  A: 도서관
  B: 교육 센터
  C: 서점
  D: 출판사
  
  정답 D: 스크립트의 "Anna Parker from Greenfield Publishing"에서 화자가 출판사에서 일하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker ask the <mark>listener</mark> to do?",
        options: {
          A: "<mark>Submit</mark> a <mark>document</mark>",
          B: "<mark>Visit</mark> an <mark>office</mark>",
          C: "Respond to an <mark>email</mark>",
          D: "<mark>Postpone</mark> a meeting",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 문서를 제출하기
  B: 사무실 방문하기
  C: 이메일에 답장하기
  D: 회의를 연기하기
  
  정답 B: 스크립트의 "We'd like you to visit our office next week"에서 사무실 방문을 요청하고 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          'What does the speaker imply when she says, "<mark>we\'re excited about working with you on this project</mark>"?',
        options: {
          A: "The <mark>project</mark> has been <mark>delayed</mark>",
          B: "The listener should <mark>finalize</mark> the <mark>manuscript</mark>",
          C: "The speaker looks forward to <mark>collaborating</mark> on the <mark>work</mark>",
          D: "The listener should <mark>submit</mark> a <mark>revised version</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 프로젝트가 지연되었다
  B: 청자가 원고를 마무리해야 한다
  C: 화자가 함께 작업하기를 기대하고 있다
  D: 청자가 수정된 버전을 제출해야 한다
  
  정답 C: 스크립트의 "We're excited about working with you on this project"에서 화자가 청자와의 협업을 기대하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk7: {
    type: "telephone",
    title: "Project Support Request",
    versions: {
      basic: {
        script: `Hello, this is Sarah from the Marketing Department. <mark>I'm calling because I need some assistance for our current project</mark>. As you know, we're working on the new product launch campaign, and there are a few areas where we could use some extra help.
We are currently facing some delays in gathering the final data for our market analysis, and <mark>I need your team's support in collecting some additional customer feedback</mark>. It would be great if we could have it by the end of this week to stay on track.
Additionally, we're short on graphic design resources. Could you assign someone from your team to <mark>help create the promotional materials? It would be really helpful if we could get these ready by the end of next week</mark>. Let me know if there's anything you need from our side to get started.
Thanks for your help!`,
        translation: `안녕하세요, 마케팅 부서의 사라입니다. 현재 진행 중인 프로젝트에 도움이 필요해서 연락드립니다. 아시다시피, 저희는 새 제품 출시 캠페인을 진행하고 있는데, 추가 지원이 필요한 부분이 몇 가지 있습니다.
현재 시장 분석을 위한 최종 데이터 수집에 지연이 있어서, 추가 고객 피드백 수집에 귀하의 팀 지원이 필요합니다. 일정을 맞추기 위해 이번 주 말까지 받을 수 있다면 좋겠습니다.
또한, 그래픽 디자인 리소스가 부족한 상황입니다. 홍보 자료 제작을 도와줄 팀원을 배정해 주실 수 있을까요? 다음 주 말까지 준비할 수 있다면 정말 도움이 될 것 같습니다. 시작하는데 필요한 것이 있다면 알려주세요.
도움 감사드립니다!`,
        audioUrl: {
          us: "audios/part4/telephone/us/us7.mp3",
          uk: "audios/part4/telephone/uk/uk7.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the speaker's call?",
        options: {
          A: "To discuss a <mark>budget issue</mark>",
          B: "To <mark>request support</mark> for a <mark>project</mark>",
          C: "To schedule a <mark>meeting</mark>",
          D: "To review <mark>market trends</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 예산 문제를 논의하기 위해
  B: 프로젝트 지원을 요청하기 위해
  C: 회의 일정을 잡기 위해
  D: 시장 동향을 검토하기 위해
  
  정답 B: 스크립트의 "I'm calling because I need some assistance for our current project"에서 프로젝트 지원을 요청하기 위한 전화임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker request from the listener's team?",
        options: {
          A: "Additional <mark>market analysis</mark>",
          B: "<mark>Customer feedback</mark> collection",
          C: "<mark>Promotion</mark> of the product",
          D: "<mark>Printing</mark> of promotional materials",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 추가 시장 분석
  B: 고객 피드백 수집
  C: 제품 홍보
  D: 홍보 자료 인쇄
  
  정답 B: 스크립트의 "I need your team's support in collecting some additional customer feedback"에서 고객 피드백 수집을 요청하고 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What is the deadline for the promotional materials?",
        options: {
          A: "The end of this week",
          B: "The end of the month",
          C: "Next Monday",
          D: "The end of next week",
        },
        correctAnswer: "D",
        explanation: `[선택지 해석]
      A: 이번 주 말
      B: 이번 달 말
      C: 다음 주 월요일
      D: 다음 주 말
      
      정답 D: 스크립트의 "It would be really helpful if we could get these ready (promotional materials) by the end of next week"에서 홍보 자료의 마감일이 다음 주 말임을 알 수 있습니다.`,
      },
    ],
  },

  talk8: {
    type: "telephone",
    title: "Interview Confirmation",
    versions: {
      basic: {
        script: `Mr. Lee, this is Sarah Park from Exemplar Consulting. I'm calling <mark>to confirm your interview</mark> scheduled for next Monday at 10 a.m. for the Marketing Manager position. Based on your resume, we believe your experience in digital campaigns matches our requirements. You requested an earlier time, and I've checked with the hiring team; <mark>we can move your interview to 9 a.m.</mark> Finally, <mark>please bring a portfolio of your past projects</mark>, as discussed. If you have any questions or need assistance, feel free to email me or call directly. Thank you for your interest.`,
        translation: `이 선생님, Exemplar Consulting의 박사라입니다. 다음 주 월요일 오전 10시에 예정된 마케팅 매니저 면접 일정을 확인하려고 연락드립니다. 이력서를 검토한 결과 디지털 캠페인 경험이 요구사항과 잘 맞는 것으로 판단했습니다. 더 이른 시간을 요청하셔서 채용팀과 확인한 결과 오전 9시로 변경이 가능합니다. 마지막으로 지난 프로젝트 포트폴리오를 지참해 주시기 바랍니다. 추가 문의나 도움이 필요하시면 이메일을 보내시거나 직접 전화해 주세요. 관심 가져주셔서 감사합니다.`,
        audioUrl: {
          us: "audios/part4/telephone/us/us8.mp3",
          uk: "audios/part4/telephone/uk/uk8.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the call?",
        options: {
          A: "To confirm an <mark>interview schedule</mark>",
          B: "To <mark>cancel</mark> an appointment",
          C: "To <mark>offer</mark> a job",
          D: "To request a <mark>resume</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 면접 일정을 확인하기 위해
  B: 약속을 취소하기 위해
  C: 채용 제안을 하기 위해
  D: 이력서를 요청하기 위해
  
  정답 A: 스크립트의 "I'm calling to confirm your interview scheduled for next Monday"에서 면접 일정을 확인하기 위한 전화임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What did the speaker do about the <mark>interview time</mark>?",
        options: {
          A: "Asked about <mark>travel arrangements</mark>",
          B: "Sent a <mark>reminder email</mark>",
          C: "Changed it to <mark>9 a.m.</mark>",
          D: "Confirmed the <mark>location</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 이동 경로를 물었다
  B: 리마인더 이메일을 보냈다
  C: 오전 9시로 변경했다
  D: 장소를 확인했다
  
  정답 C: 스크립트의 "we can move your interview to 9 a.m."에서 면접 시간을 오전 9시로 변경했음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          'Why does the speaker say "<mark>please bring a portfolio of your past projects</mark>"?',
        options: {
          A: "To request <mark>supporting materials</mark>",
          B: "To explain interview <mark>location</mark>",
          C: "To confirm time <mark>adjustment</mark>",
          D: "To discuss <mark>salary expectations</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
      A: 증빙 자료를 요청하기 위해
      B: 면접 장소를 설명하기 위해
      C: 시간 변경을 확인하기 위해
      D: 급여 협상 사항을 논의하기 위해
      
      정답 A: 스크립트의 "please bring a portfolio of your past projects"에서 면접 시 포트폴리오라는 증빙 자료를 요청하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk9: {
    type: "telephone",
    title: "Dry Cleaning Order Update",
    versions: {
      basic: {
        script: `Hello, this is Daniel Kim from Radiant Cleaners. I'm <mark>calling regarding your dry cleaning</mark> order for your winter coat. The cleaning is complete, but our <mark>stain removal specialist found an area that needs additional treatment</mark> today. I spoke with the manager this afternoon, and we plan to finish the extra cleaning by tomorrow morning.
We can <mark>arrange delivery to your home between 2 and 4 pm or you can pick it up at our Downtown Branch</mark>. Please let us know your preference at your earliest convenience.
If you have any questions or need further assistance, <mark>please email or call me</mark>. Thank you.`,
        translation: `안녕하세요, Radiant Cleaners의 Daniel Kim입니다. 귀하의 겨울 코트 드라이클리닝 주문과 관련하여 전화드립니다. 세탁은 완료되었으나 얼룩 제거 전문가가 오늘 추가 처리가 필요한 부분을 발견했습니다. 오늘 오후 매니저와 협의하여 내일 아침까지 추가 세탁을 마칠 예정입니다.
오후 2시부터 4시 사이에 집으로 배송하거나 Downtown Branch에서 직접 찾으실 수 있습니다. 편하신 방법을 가능한 한 빨리 알려주십시오.
문의 사항이나 추가 도움이 필요하시면 이메일 또는 전화 주시기 바랍니다. 감사합니다.`,
        audioUrl: {
          us: "audios/part4/telephone/us/us9.mp3",
          uk: "audios/part4/telephone/uk/uk9.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the call?",
        questionKr: "화자가 전화를 건 주요 목적은 무엇인가?",
        options: {
          A: "To update about <mark>dry cleaning</mark>",
          B: "To request <mark>payment</mark>",
          C: "To offer a <mark>discount</mark>",
          D: "To change the <mark>service location</mark>",
        },
        optionsKr: {
          A: "드라이클리닝 상황을 알리기 위해",
          B: "결제를 요청하기 위해",
          C: "할인을 제안하기 위해",
          D: "서비스 장소를 변경하기 위해",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 드라이클리닝 상황을 알리기 위해
  B: 결제를 요청하기 위해
  C: 할인을 제안하기 위해
  D: 서비스 장소를 변경하기 위해
  
  정답 A: 스크립트의 "I'm calling regarding your dry cleaning order for your winter coat"에서 드라이클리닝 상황을 알리기 위한 전화임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What did the stain removal <mark>specialist find</mark>?",
        questionKr: "얼룩 제거 전문가는 무엇을 발견했는가?",
        options: {
          A: "A <mark>missing button</mark>",
          B: "An area needing <mark>extra treatment</mark>",
          C: "A <mark>tear</mark> in the fabric",
          D: "Incorrect cleaning <mark>instructions</mark>",
        },
        optionsKr: {
          A: "단추 하나가 빠진 것을",
          B: "추가 처리가 필요한 부분을",
          C: "옷감에 찢어진 자국을",
          D: "잘못된 세탁 지시를",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 단추 하나가 빠진 것을
  B: 추가 처리가 필요한 부분을
  C: 옷감에 찢어진 자국을
  D: 잘못된 세탁 지시를
  
  정답 B: 스크립트의 "stain removal specialist found an area that needs additional treatment"에서 추가 처리가 필요한 부분을 발견했음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What options does the speaker offer?",
        questionKr: "화자는 어떤 선택지를 제시하는가?",
        options: {
          A: "A <mark>refund</mark> <mark>or</mark> <mark>replacement</mark>",
          B: "<mark>Delivery</mark> <mark>time</mark> <mark>or</mark> in‑branch <mark>pickup</mark>",
          C: "Extended <mark>warranty</mark> <mark>or</mark> free <mark>trial</mark>",
          D: "<mark>Payment plan</mark> <mark>or</mark> full <mark>payment</mark>",
        },
        optionsKr: {
          A: "환불 또는 교환",
          B: "배송 시간 또는 지점 직접 수령",
          C: "연장 보증 또는 무료 체험",
          D: "할부 결제 또는 일시불 결제",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 환불 또는 교환
  B: 배송 시간 또는 지점 직접 수령
  C: 연장 보증 또는 무료 체험
  D: 할부 결제 또는 일시불 결제
  
  정답 B: 스크립트의 "We can arrange delivery to your home between 2 and 4 pm or you can pick it up at our Downtown Branch"에서 배송 시간 또는 지점 직접 수령 옵션을 제시하고 있음을 알 수 있습니다.`,
      },
    ],
  },
  talk10: {
    type: "telephone",
    title: "Healthcare Appointment Update",
    versions: {
      basic: {
        script: `Hello, this is Samantha from Wellness Health Clinic. I'm calling to <mark>confirm your appointment</mark> for a routine check-up tomorrow at 10 A.M. However, I wanted to let you know that <mark>Dr. Matthews is running behind due to an emergency consultation this morning</mark>. Unfortunately, your appointment might be delayed by about 30 minutes.
We'll keep you updated on any further delays, and we appreciate your patience. <mark>If you prefer, we can reschedule the appointment to a later time</mark>. Please let me know if you'd like to do that.
Thank you for understanding, and we look forward to seeing you tomorrow.`,
        translation: `안녕하세요, 웰니스 헬스 클리닉의 사만다입니다. 내일 오전 10시로 예정된 정기 검진 예약을 확인하고자 연락드렸습니다. 하지만 오늘 아침 응급 진료로 인해 매튜스 박사의 일정이 지연되고 있어서 알려드리고 싶었습니다. 죄송하지만, 귀하의 예약이 약 30분 정도 지연될 수 있습니다.
추가 지연이 있을 경우 계속 알려드리도록 하겠으며, 양해해 주셔서 감사합니다. 원하신다면, 더 늦은 시간으로 예약을 변경해 드릴 수 있습니다. 그렇게 하시고 싶으시다면 알려주시기 바랍니다.
이해해 주셔서 감사드리며, 내일 뵙기를 기대하겠습니다.`,
        audioUrl: {
          us: "audios/part4/telephone/us/us10.mp3",
          uk: "audios/part4/telephone/uk/uk10.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the call?",
        options: {
          A: "To inform the listener about a <mark>new clinic policy</mark>",
          B: "To confirm an <mark>appointment</mark>",
          C: "To offer a <mark>discount</mark> for the delayed appointment",
          D: "To explain the cause of the <mark>delay</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 새로운 클리닉 정책을 알리기 위해
  B: 예약을 확인하기 위해
  C: 지연된 예약에 대한 할인을 제안하기 위해
  D: 지연의 원인을 설명하기 위해
  
  정답 B: 스크립트의 "I'm calling to confirm your appointment"에서 예약을 확인하기 위한 전화임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What caused the <mark>delay</mark> in the appointment?",
        options: {
          A: "A system <mark>malfunction</mark>",
          B: "A medical <mark>emergency</mark>",
          C: "A <mark>scheduling conflict</mark>",
          D: "A <mark>traffic</mark> issue",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 시스템 오작동
  B: 의료 응급상황
  C: 일정 충돌
  D: 교통 문제
  
  정답 B: 스크립트의 "Dr. Matthews is running behind due to an emergency consultation this morning"에서 응급 진료(의료 응급상황)가 원인임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker offer the listener?",
        options: {
          A: "A different <mark>doctor</mark>",
          B: "A later appointment <mark>time</mark>",
          C: "A <mark>free consultation</mark>",
          D: "A <mark>refund</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 다른 의사
  B: 더 늦은 예약 시간
  C: 무료 상담
  D: 환불
  
  정답 B: 스크립트의 "If you prefer, we can reschedule the appointment to a later time"에서 더 늦은 시간으로 예약을 변경할 수 있다고 제안했음을 알 수 있습니다.`,
      },
    ],
  },
  talk11: {
    type: "telephone",
    title: "Delivery Issue Report",
    versions: {
      basic: {
        script: `Hello, this is Maria Lopez calling regarding an order I placed with your company. The item I ordered, a set of garden furniture, arrived yesterday. However, <mark>I noticed that one of the chairs is missing a leg and is completely unusable</mark>. <mark>I've attached photos for reference</mark>, and I'd like to know how we can resolve this issue. <mark>Could you arrange for a replacement to be sent</mark> as soon as possible?
If needed, I can provide further details about the delivery, but I would like to get this sorted out as quickly as possible. Please give me a call back when you have an update.`,
        translation: `안녕하세요, 귀사에 주문한 건과 관련하여 마리아 로페즈가 연락드립니다. 제가 주문한 정원용 가구 세트가 어제 도착했습니다. 하지만 의자 하나의 다리가 없어서 전혀 사용할 수 없는 상태입니다. 참고용 사진을 첨부했으며, 이 문제를 어떻게 해결할 수 있는지 알고 싶습니다. 가능한 한 빨리 교체품을 보내주실 수 있을까요?
필요하다면 배송에 대한 추가 세부사항을 제공할 수 있지만, 최대한 빨리 이 문제가 해결되었으면 합니다. 업데이트가 있으시면 연락 주시기 바랍니다.`,
        audioUrl: {
          us: "audios/part4/telephone/us/us11.mp3",
          uk: "audios/part4/telephone/uk/uk11.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the problem with the furniture?",
        options: {
          A: "It is <mark>missing parts</mark>",
          B: "It is too <mark>small</mark>",
          C: "It is <mark>damaged</mark>",
          D: "It is the <mark>wrong color</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 부품이 없음
  B: 너무 작음
  C: 손상됨
  D: 잘못된 색상임
  
  정답 A: 스크립트의 "one of the chairs is missing a leg"에서 가구의 부품이 없다는 것을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker provide to help resolve the issue?",
        options: {
          A: "A <mark>return slip</mark>",
          B: "A <mark>photograph</mark> of the damaged item",
          C: "The delivery <mark>confirmation number</mark>",
          D: "The store <mark>receipt</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 반품 전표
  B: 손상된 물품의 사진
  C: 배송 확인 번호
  D: 상점 영수증
  
  정답 B: 스크립트의 "I've attached photos for reference"에서 문제 해결을 위해 사진을 제공했음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What is the speaker requesting from the company?",
        options: {
          A: "A <mark>refund</mark> for the item",
          B: "A new <mark>delivery date</mark>",
          C: "A <mark>replacement item</mark>",
          D: "A store <mark>credit</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 물품에 대한 환불
  B: 새로운 배송 날짜
  C: 교체 물품
  D: 상점 크레딧
  
  정답 C: 스크립트의 "Could you arrange for a replacement to be sent"에서 교체 물품을 요청하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk13: {
    type: "telephone",
    title: "Laptop Borrowing Request",
    versions: {
      basic: {
        script: `Hello, Jane. This is Rachel. <mark>I was wondering if I could borrow your laptop for a few days next week</mark>. <mark>I need to finish a project for work</mark>, and my laptop broke down unexpectedly. I'd really appreciate it if I could borrow it for a couple of days, from Tuesday morning until Thursday evening. I won't need it for the weekend, so I'll return it by Thursday night. <mark>If that's not convenient, I can look into renting one</mark>. Just let me know what you think when you have time. Thanks!`,
        translation: `안녕하세요, 제인. 레이첼입니다. 다음 주에 며칠 동안 노트북을 빌릴 수 있을지 궁금합니다. 업무용 프로젝트를 마무리해야 하는데, 제 노트북이 갑자기 고장 났거든요. 화요일 아침부터 목요일 저녁까지 이틀 정도 빌릴 수 있다면 정말 감사하겠습니다. 주말에는 필요 없어서, 목요일 밤까지 돌려드리겠습니다. 불편하시다면, 대여하는 것도 알아볼 수 있습니다. 시간 되실 때 어떻게 생각하시는지 알려주세요. 감사합니다!`,
        audioUrl: {
          us: "audios/part4/telephone/us/us13.mp3",
          uk: "audios/part4/telephone/uk/uk13.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the speaker asking for?",
        options: {
          A: "<mark>Permission</mark> to use a <mark>laptop</mark>",
          B: "An <mark>extension</mark> for a work <mark>project</mark>",
          C: "A <mark>recommendation</mark> for a <mark>rental laptop</mark>",
          D: "<mark>Help</mark> with a <mark>work project</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 노트북 사용 허가
  B: 업무 프로젝트 기한 연장
  C: 대여 노트북 추천
  D: 업무 프로젝트 도움
  
  정답 A: 스크립트의 "I was wondering if I could borrow your laptop"에서 노트북 사용 허가를 요청하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "Why does the speaker need <mark>the laptop</mark>?",
        options: {
          A: "To complete a <mark>work</mark> <mark>project</mark>",
          B: "To attend an <mark>online meeting</mark>",
          C: "To prepare for a <mark>presentation</mark>",
          D: "To do <mark>personal tasks</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 업무 프로젝트를 완료하기 위해
  B: 온라인 회의에 참석하기 위해
  C: 프레젠테이션을 준비하기 위해
  D: 개인적인 일을 하기 위해
  
  정답 A: 스크립트의 "I need to finish a project for work"에서 업무 프로젝트를 완료하기 위해 노트북이 필요하다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker suggest in case the request is <mark>not possible</mark>?",
        options: {
          A: "Ask for a <mark>loan</mark>",
          B: "Look into <mark>renting a laptop</mark>",
          C: "Wait until the <mark>weekend</mark>",
          D: "Try to find a <mark>backup laptop</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 대출을 요청하기
  B: 노트북 대여를 알아보기
  C: 주말까지 기다리기
  D: 백업 노트북을 찾아보기
  
  정답 B: 스크립트의 "If that's not convenient, I can look into renting one"에서 노트북 대여를 대안으로 제시하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk16: {
    type: "telephone",
    title: "Book Borrowing Request",
    versions: {
      basic: {
        script: `Hi Daniel, it's Lisa. I hope you're doing well. I'm calling because I need a favor. <mark>I've been looking for a book on business strategies, and I remember you mentioning that you have a great one. I was wondering if I could borrow it for a few days</mark>.
<mark>I have a big presentation coming up next week</mark>, and I think the book would be really helpful for my research. If it's okay with you, <mark>I promise to take good care of it and return it by Friday</mark>.
Let me know if that works for you. Thanks so much!`,
        translation: `안녕하세요 다니엘, 리사입니다. 잘 지내시길 바랍니다. 부탁드릴 것이 있어서 연락드립니다. 비즈니스 전략에 관한 책을 찾고 있었는데, 다니엘 씨가 좋은 책을 가지고 계시다고 언급하신 것이 기억났어요. 며칠 동안 빌릴 수 있을지 궁금합니다.
다음 주에 중요한 발표가 있어서, 제 연구에 그 책이 정말 도움이 될 것 같아요. 괜찮으시다면, 책을 잘 관리하고 금요일까지 반납하겠다고 약속드립니다.
가능하신지 알려주세요. 정말 감사합니다!`,
        audioUrl: {
          us: "audios/part4/telephone/us/us16.mp3",
          uk: "audios/part4/telephone/uk/uk16.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What does the speaker ask for?",
        options: {
          A: "To <mark>borrow</mark> a business <mark>book</mark>",
          B: "To <mark>buy</mark> a <mark>book</mark> on business strategies",
          C: "To <mark>recommend</mark> a good <mark>book</mark>",
          D: "To <mark>lend</mark> a <mark>book</mark> to a friend",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 비즈니스 책을 빌리기 위해
  B: 비즈니스 전략에 관한 책을 구매하기 위해
  C: 좋은 책을 추천받기 위해
  D: 친구에게 책을 빌려주기 위해
  
  정답 A: 스크립트의 "I was wondering if I could borrow it for a few days"에서 비즈니스 책을 빌리고 싶어한다는 것을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "Why does the speaker need the book?",
        options: {
          A: "She wants to improve her <mark>writing skills</mark>",
          B: "She is preparing for a business <mark>presentation</mark>",
          C: "She needs it for a book <mark>review</mark>",
          D: "She wants to <mark>start a business</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 글쓰기 실력을 향상시키고 싶어서
  B: 비즈니스 발표를 준비하고 있어서
  C: 책 리뷰를 위해 필요해서
  D: 사업을 시작하고 싶어서
  
  정답 B: 스크립트의 "I have a big presentation coming up next week"에서 발표 준비를 위해 책이 필요하다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker promise to do?",
        options: {
          A: "<mark>Return</mark> the book in good condition",
          B: "<mark>Buy</mark> a new book after borrowing it",
          C: "<mark>Share a summary</mark> of the book",
          D: "Return the book <mark>next month</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 책을 좋은 상태로 반환하기
  B: 책을 빌린 후 새것을 구매하기
  C: 책의 요약본을 공유하기
  D: 다음 달에 책을 반환하기
  
  정답 A: 스크립트의 "I promise to take good care of it and return it by Friday"에서 책을 잘 관리하고(좋은 상태로) 반환하겠다는 약속을 하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk18: {
    type: "telephone",
    title: "Delivery Address Issue",
    versions: {
      basic: {
        script: `Hello, Ms. Johnson. This is Peter from QuickShip Logistics. I'm calling regarding the package you ordered last week. <mark>We attempted delivery yesterday, but it was unsuccessful because the shipping address provided appears to be incorrect</mark>.
        According to our records, the address listed on your order is 215 Greenway Avenue, Apartment 5B, but the delivery team reported that they couldn't locate the apartment number. <mark>To complete the delivery, we need you to verify your address</mark>. You can either confirm the current address or provide a new one if necessary.
        <mark>Once we receive the correct details, we will arrange for a redelivery at no extra charge</mark>. Please call me back at your earliest convenience so we can complete the process. Thank you.`,
        translation: `안녕하세요, 존슨 님. 퀵쉽 로지스틱스의 피터입니다. 지난주에 주문하신 패키지와 관련하여 연락드립니다. 어제 배송을 시도했으나, 제공된 배송 주소가 정확하지 않아 배송이 실패했습니다.
        저희 기록에 따르면, 주문서에 기재된 주소는 215 그린웨이 애비뉴, 아파트 5B인데, 배송팀이 아파트 호수를 찾을 수 없었다고 보고했습니다. 배송을 완료하기 위해서는 주소 확인이 필요합니다. 현재 주소를 확인하시거나 필요한 경우 새로운 주소를 제공해 주시면 됩니다.
        정확한 정보를 받는 대로 추가 비용 없이 재배송을 진행하도록 하겠습니다. 절차를 완료할 수 있도록 편하실 때 연락 주시기 바랍니다. 감사합니다.`,
        audioUrl: {
          us: "audios/part4/telephone/us/us18.mp3",
          uk: "audios/part4/telephone/uk/uk18.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem does the speaker mention?",
        options: {
          A: "The <mark>recipient</mark> was not available for delivery",
          B: "The <mark>shipping address</mark> is incorrect",
          C: "The package was <mark>damaged</mark> during transit",
          D: "The order was <mark>canceled</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 수령인이 배송 시 부재중이었음
  B: 배송 주소가 잘못되었음
  C: 운송 중 패키지가 손상되었음
  D: 주문이 취소되었음
  
  정답 B: 스크립트의 "We attempted delivery yesterday, but it was unsuccessful because the shipping address provided appears to be incorrect"에서 배송 주소가 잘못되었다는 것을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker ask the <mark>listener</mark> to do?",
        options: {
          A: "Confirm the <mark>shipping address</mark>",
          B: "<mark>Pay</mark> an additional delivery <mark>fee</mark>",
          C: "Pick up the package at a <mark>local store</mark>",
          D: "Reschedule the delivery for <mark>next week</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 배송 주소 확인하기
  B: 추가 배송 요금 지불하기
  C: 현지 매장에서 패키지 수령하기
  D: 다음 주로 배송 일정 변경하기
  
  정답 A: 스크립트의 "To complete the delivery, we need you to verify your address"에서 배송 주소 확인을 요청하고 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What is the company's next step?",
        options: {
          A: "Send a <mark>new package</mark>",
          B: "Provide a <mark>refund</mark>",
          C: "Attempt <mark>redelivery</mark> once the address is confirmed",
          D: "<mark>Cancel</mark> the order permanently",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 새 패키지 발송하기
  B: 환불 제공하기
  C: 주소 확인 후 재배송 시도하기
  D: 주문 영구 취소하기
  
  정답 C: 스크립트의 "Once we receive the correct details, we will arrange for a redelivery at no extra charge"에서 주소 확인 후 재배송을 시도할 것임을 알 수 있습니다.`,
      },
    ],
  },
  talk19: {
    type: "telephone",
    title: "Exhibition Schedule Change Notice",
    versions: {
      basic: {
        script: `Hello, you've reached the administrative office of the Riverton Museum of Modern Art. We are calling to inform you about a schedule change for our upcoming exhibition, "Abstract Visions: A Retrospective".
        Originally, the exhibition was scheduled to open on September 10th, but <mark>due to unexpected delays in the shipment of some key artworks, we have postponed the opening date to September 17th</mark>.
        <mark>If you have already purchased tickets for the original opening date, they will be valid for any date after the new opening</mark>. <mark>If you prefer to request a refund, please visit our website or contact our contact center</mark>.
        Thank you for your understanding, and we look forward to welcoming you to the exhibition.`,
        translation: `안녕하세요, 리버튼 현대 미술관 행정실입니다. 다가오는 전시회 "추상적 비전: 회고전"의 일정 변경에 대해 알려드리고자 연락드렸습니다.
        원래 전시회는 9월 10일에 개막 예정이었으나, 일부 주요 작품들의 배송이 예상치 못하게 지연되어 개막일을 9월 17일로 연기하게 되었습니다.
        이미 원래 개막일 티켓을 구매하신 분들은 새로운 개막일 이후 아무 날짜에나 사용하실 수 있습니다. 환불을 원하시는 경우, 저희 웹사이트를 방문하시거나 고객센터로 연락 주시기 바랍니다.
        양해해 주셔서 감사드리며, 전시회에서 여러분을 맞이하기를 기대하고 있습니다.`,
        audioUrl: {
          us: "audios/part4/telephone/us/us19.mp3",
          uk: "audios/part4/telephone/uk/uk19.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "Why is the exhibition schedule being changed?",
        options: {
          A: "The <mark>venue</mark> is under <mark>renovation</mark>",
          B: "An <mark>artist's availability</mark> has changed",
          C: "Some <mark>artwork shipments</mark> were <mark>delayed</mark>",
          D: "The museum's <mark>operating hours</mark> have changed",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 전시장이 보수 공사 중이어서
  B: 예술가의 일정이 변경되어서
  C: 일부 작품 배송이 지연되어서
  D: 박물관 운영 시간이 변경되어서
  
  정답 C: 스크립트의 "due to unexpected delays in the shipment of some key artworks"에서 작품 배송 지연이 일정 변경의 이유임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "According to the speaker, what will happen to <mark>previously purchased tickets</mark>?",
        options: {
          A: "They will need to be <mark>exchanged</mark> for new ones",
          B: "They will be <mark>valid</mark> for <mark>any date</mark> after the <mark>new opening</mark>",
          C: "They will <mark>only</mark> be <mark>valid</mark> for the <mark>new opening</mark> day",
          D: "They will be <mark>refunded</mark> <mark>automatically</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 새 티켓으로 교환해야 함
  B: 새로운 개막일 이후 아무 날짜나 사용 가능
  C: 새로운 개막일에만 사용 가능
  D: 자동으로 환불됨
  
  정답 B: 스크립트의 "they will be valid for any date after the new opening"에서 새로운 개막일 이후 아무 날짜나 사용할 수 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker ask listeners to do if they want a <mark>refund</mark>?",
        options: {
          A: "Visit the museum <mark>in person</mark>",
          B: "Call the <mark>ticket office</mark>",
          C: "Visit the <mark>website</mark> or contact the <mark>contact center</mark>",
          D: "Request a refund by <mark>email</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
      A: 박물관에 직접 방문하기
      B: 티켓 사무실에 전화하기
      C: 웹사이트를 방문하거나 고객센터에 연락하기
      D: 이메일로 환불 요청하기
      
      정답 C: 스크립트의 "If you prefer to request a refund, please visit our website or contact our contact center"에서 웹사이트 방문이나 고객센터 연락을 통해 환불을 요청할 수 있다는 것을 알 수 있습니다.`,
      },
    ],
  },
};
